import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomFieldModel } from 'src/app/core/models/document/custom-field-model';
import { InvoiceModel } from 'src/app/core/models/commerce/invoice.model';
import { MyfileModalComponent } from '../myfile-modal/myfile-modal.component';
import { DocumentStatus } from 'src/app/core/models/document/document-template-model';

@Component({
  selector: 'app-invoice-myfile-modal',
  templateUrl: './invoice-myfile-modal.component.html',
  styleUrls: ['./invoice-myfile-modal.component.scss']
})
export class InvoiceMyfileModalComponent extends MyfileModalComponent {

  @Input() invoice: InvoiceModel = new InvoiceModel();
  
  override save() {
    if (this.validation()) {
      this.submitted = false;
      this.spinnerIsShown = true;
      this.myFileApiService.updateMyFile(this.myfile).subscribe(result => {
        if (result) {
          this.myFileApiService.updateInvoice(this.invoiceSetUp(this.invoice)).subscribe(updated => {
            this.spinnerIsShown = false;
            this.modalRef.close();
          });
        } else {
          this.spinnerIsShown = false;
        }
      });
    }
  }
  override viewMyfile() {
    this.spinnerIsShown = true;
    if (this.validation()) {
      this.myFileApiService.updateMyFile(this.myfile).subscribe(result => {
        if (result) {
          this.myFileApiService.updateInvoice(this.invoiceSetUp(this.invoice)).subscribe(updated => {
            this.spinnerIsShown = false;
            if (this.requisition!.id && this.myfile.id) {
              this.myFileApiService.viewMyFile(this.requisition!.id, this.myfile.id).subscribe((result: any) => {
                this.pdfModalService.openModal(result, this.myfile.name);
                var sub: Subscription = this.pdfModalService.modelChanged.subscribe(() => {
                  this.spinnerIsShown = false;
                  sub.unsubscribe();
                })
              });
            }
          });
        } else {
          this.spinnerIsShown = false;
        }
      });
    } else {
      this.spinnerIsShown = false;
    }
  }

  override printMyfile() {
    this.spinnerIsShown = true;
    if (this.validation()) {
      this.submitted = false;
      this.invoiceSetUp(this.invoice); this.spinnerIsShown = false;
      this.myFileApiService.updateMyFile(this.myfile).subscribe(result => {
        if (result) {
          this.myFileApiService.updateInvoice(this.invoiceSetUp(this.invoice)).subscribe(updated => {
            if (this.myfile.sourceId && this.myfile.id) {
              this.myFileApiService.printMyFile(this.myfile.sourceId, this.myfile.id).subscribe((result: any) => {
                this.spinnerIsShown = false
              });
            } else {
              this.spinnerIsShown = false
            }
          });
        } else {
          this.spinnerIsShown = false;
        }
      });
    } else {
      this.spinnerIsShown = false
    }
  }

  invoiceSetUp(invoiceIn: InvoiceModel): InvoiceModel {
    var invoice: any = { ...new InvoiceModel, ...invoiceIn };
    this.myfile!.customFields!.forEach((customField: CustomFieldModel) => {
      switch (customField.name) {
        case "Price":
          invoice.price = customField.value;
          invoice.lineItems[0].rate = customField.value;
          invoice.lineItems[0].quantity = 1;
          break;
        case "ProcessingFee":
          invoice.processingFee = customField.value;
          invoice.lineItems[1].rate = customField.value;
          invoice.lineItems[1].quantity = 1;
          break;
        case "PriceDesc":
          if (customField.value && customField.value.length > 0) {
            invoice.lineItems[0].description = customField.value;
          }
          break;
        case "AdditionalFee":
          invoice.additionalFee = customField.value;
          invoice.lineItems[2].rate = customField.value;
          invoice.lineItems[2].quantity = 1;
          break;
        case "AdditionalFeeDesc":
          if (customField.value && customField.value.length > 0) {
            invoice.lineItems[2].description = customField.value;
          }
          break;
      }
    })
    return invoice;
  }

  validation(): boolean {
    this.submitted = true;
    if (this.myfile.customFields![0].value == null || this.myfile.customFields![0].value == '') {
      this.myfile.customFields![0].value = "0.00"
    } else {
      if (!this.myfile.customFields![0].value.includes('.')) {
        this.myfile.customFields![0].value = `${this.myfile.customFields![0].value}.00`
      }
    }
    if (this.myfile.customFields![1].value == null || this.myfile.customFields![1].value == '') {
      this.myfile.customFields![1].value = "0.00"
    } else {
      if (!this.myfile.customFields![1].value.includes('.')) {
        this.myfile.customFields![1].value = `${this.myfile.customFields![1].value}.00`
      }
    }
    if (this.myfile.customFields![2].value == null || this.myfile.customFields![2].value == '') {
      this.myfile.customFields![2].value = "0.00"
    } else {
      if (!this.myfile.customFields![2].value.includes('.')) {
        this.myfile.customFields![2].value = `${this.myfile.customFields![2].value}.00`
      }
    }
    return true
  }
}
